import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
/////////////////////////////////////// SUPER ADMIN SELECT HEADER-STAFF AND MAKE IT WITHOUT STAFF
import HeaderStaff from "../Component/Dynamic/HeaderStaff";
import { useTranslation } from "react-i18next";
import { BasicColor, GreenContrast } from "../Utils/constants";
import UploadDocs from "./UploadDocsScr";
import "../App.css";
import Footer from "../Component/Dynamic/Footer";
import AdminLogin from "./Admin";
import DoctorChatDashboard from "../Component/Dynamic/DocPortal";
import ChatAppScr from "../Screens/ChatAppScr";
import MainScr from "./MainScr";
import Locations from "./locations";

function Home() {
  const [showPasswordModal, setShowPasswordModal] = useState(
    localStorage.getItem("privilegeLevel") || "secretary"
  );
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    document.documentElement.style.setProperty("--primary-color", BasicColor);
  }, []);

  /////////////////////////////////////////////////////////////////////////////
  // Handling Modal views
  /////////////////////////////////////////////////////////////////////////////

  const [modalShowAdminLogin, setmodalShowAdminLogin] = useState(false);
  function handleModalShowAdminLogin(value) {
    setmodalShowAdminLogin(value);
    // console.log("value", value);
  }

  const handleTabClosing = () => {
    localStorage.setItem("isLogged", false);
  };

  const alertUser = (event) => {
    console.log("logout event", event);
    // event.preventDefault();
    event.returnValue = "jjjjjj";
  };

  return (
    <div
      className="App"
      style={{
        backgroundColor: location.pathname === "/chat" ? GreenContrast : "",
      }}
    >
      <div>
        <HeaderStaff />
        <div>
          <Routes>
            <Route path="/" element={<MainScr />} />
            <Route path="/upload" element={<UploadDocs />} />
            <Route path="/ptupload" element={<UploadDocs />} />
            <Route path="/chat" element={<ChatAppScr />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/docchat" element={<DoctorChatDashboard />} />
            <Route path="/targets" element={<Locations />} />
          </Routes>
        </div>
        {location.pathname !== "/chat" && location.pathname !== "/admin" && (
          <Footer />
        )}
      </div>
    </div>
  );
}

export default Home;
